import { render, staticRenderFns } from "./Lenders.vue?vue&type=template&id=543764c2&"
import script from "./Lenders.vue?vue&type=script&lang=ts&"
export * from "./Lenders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports